import * as React from "react";
const SvgFiRrScribble = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-scribble_svg__a)">
      <path
        fill="#062147"
        d="M23.823 20.04a1 1 0 0 1-.256 1.39c-1.109.765-3.962 2.543-6.497 2.543-1.298 0-2.5-.487-3.385-1.372a4.66 4.66 0 0 1-1.373-3.314c0-1.252.488-2.43 1.373-3.314l7.893-7.894a1.5 1.5 0 0 0 .44-1.06 1.5 1.5 0 0 0-.44-1.062c-.566-.565-1.555-.567-2.12 0l-13.5 13.5c-1.322 1.322-3.628 1.322-4.95 0a3.48 3.48 0 0 1-1.026-2.475c0-.935.364-1.814 1.025-2.475l10.057-9.95a1.5 1.5 0 0 0-.004-2.117c-.566-.566-1.555-.566-2.12 0L1.701 9.572A1 1 0 1 1 .297 8.148L7.53 1.021c1.312-1.312 3.623-1.317 4.945.005a3.504 3.504 0 0 1 0 4.95l-10.058 9.95a1.49 1.49 0 0 0-.435 1.057c0 .402.156.777.44 1.061.565.565 1.554.567 2.12 0l13.5-13.5c1.321-1.322 3.627-1.322 4.95 0a3.48 3.48 0 0 1 1.025 2.475c0 .935-.364 1.814-1.025 2.475L15.1 17.388a2.67 2.67 0 0 0-.787 1.9c0 .717.28 1.393.787 1.9s1.208.786 1.971.786c2.028 0 4.617-1.676 5.362-2.189a1 1 0 0 1 1.391.256z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-scribble_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrScribble;
